import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { SmartToy as BotIcon } from '@mui/icons-material';
import PrivacyAssistantChat from '../components/privacyAssistant/PrivacyAssistantChat';
import { tokens } from '../theme/tokens';

/**
 * Full-page Privacy Assistant (grounded `/api/chatbot/message/`), linked from the sidebar.
 */
const PrivacyAssistantPage = () => {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
      }}
    >
      <Container
        maxWidth="md"
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          py: { xs: 2, md: 3 },
          pb: { xs: 3, md: 4 },
        }}
      >
        <Box
          sx={{
            p: { xs: 2, sm: 2.5 },
            mb: 2,
            borderRadius: `${tokens.radius.card}px`,
            border: tokens.hero.border,
            boxShadow: tokens.hero.shadow,
            background: tokens.hero.gradient,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
            <Box
              sx={{
                p: 1,
                borderRadius: 2,
                bgcolor: 'rgba(255, 255, 255, 0.12)',
                display: 'flex',
              }}
            >
              <BotIcon sx={{ fontSize: 28, color: tokens.text.primary }} />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: '-0.02em', color: tokens.text.primary }}>
                Privacy Assistant
              </Typography>
              <Typography variant="body2" sx={{ color: tokens.text.secondary, mt: 0.75, maxWidth: 640 }}>
                Answers use only your SafeSocial scan data (risk score, exposures, platforms). This is not legal advice
                and does not guarantee outcomes.
              </Typography>
            </Box>
          </Box>
        </Box>

        <PrivacyAssistantChat variant="page" />
      </Container>
    </Box>
  );
};

export default PrivacyAssistantPage;
